import { Component, OnInit } from '@angular/core';
import { SharedMethods } from '../services/sharedMethods-service';

@Component({
  selector: 'app-banner-promotion',
  templateUrl: './banner-promotion.component.html',
  styleUrls: ['./banner-promotion.component.sass']
})
export class BannerPromotionComponent implements OnInit {

  bannerpromotion = '';
  linkBannerPromotion = '';
  constructor(private sharedMethods: SharedMethods) {

    if(this.sharedMethods.cacheSettings === undefined) {

      this.sharedMethods.getSettings().subscribe(setting => {
        this.sharedMethods.cacheSettings = setting;
        this.bannerpromotion = this.sharedMethods.cacheSettings.bannerPromotion;
      });

    } else {

      this.bannerpromotion = this.sharedMethods.cacheSettings.bannerPromotion;
      this.linkBannerPromotion = this.sharedMethods.cacheSettings.linkBannerPromotion;
    }

  }

  ngOnInit() {
  }

}
